<!-- 门店管理--门店列表 -->

<template>
  <div class="vip-container main-cnt">
    <div class="title">门店列表</div>

    <!-- 列表数据 -->
    <div class="content">
      <common-table ref="tableRef" tableHeight="calc(100vh - 320px)" :ischeck="false" :filters="filters"
        :ispaging="true" :apiName="StoreApi.getPolymerizations" :columns="tableColumns" @edit="openDialog"
        @vipClick="openCommodity" @statusChange="changePolymerizationStatus" @netConfig="openNetConfig" @collection="openCollection" @verifier="openVerifier">
        <template #operate>
          <el-button type="primary" round @click="openDialog"
            v-if="authData.indexOf('n_5A4933F3F76A921A0742FC3A756E') != -1">
            <el-icon><i class="iconfont icon-a-lianhe4"></i></el-icon>
            新增门店
          </el-button>
        </template>
        <template #refund_status="{ row }" >
          <!-- 有权限 -->
          <template v-if="authData.indexOf('n_gSag7P4TU4gUsIXpgDVliMP831') != -1">
            <el-popconfirm :title="`确定要${row.pom_refund_status == 2 ? '关闭' : '开启'}退款审核吗?`" @confirm="refundStatusChange(row)">
              <template #reference>
                <el-switch
                  v-model="row.pom_refund_status"
                  inline-prompt
                  active-text="开"
                  inactive-text="关"
                  :width="45"
                  :active-value="2"
                  :inactive-value="1"
                  :before-change="() => false"
                />
              </template>
            </el-popconfirm>
          </template>
          <!-- 没有权限 -->
          <template v-else>
            <el-switch
              v-model="row.pom_refund_status"
              inline-prompt
              active-text="开"
              inactive-text="关"
              :width="45"
              :active-value="2"
              :inactive-value="1"
              :before-change="() => false"
              :disabled="true"
            />
          </template>
        </template>
      </common-table>
    </div>

    <!-- 新增、编辑门店对话框 -->
    <w-dialog ref="dialogRef" class="vip-dialog" :title="ruleForm.pom_id ? '编辑门店' : '新增门店'" width="50%" btnWidth="140px"
      top="20vh" :confirmText="ruleForm.pom_id ? '确认编辑' : '确认新增'" @wConfirm="handleSure">
      <el-form class="add-form" ref="formRef" :model="ruleForm" :rules="rules" labelPosition="top">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="选择项目" prop="pom_pid">
              <el-select v-model="ruleForm.pom_pid" clearable placeholder="请选择项目">
                <el-option :label="item.p_name" :value="item.p_id" v-for="item in projectOptions" :key="item.p_id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="选择门店所属分类" prop="pom_type">
              <el-select v-model="ruleForm.pom_type" clearable placeholder="请选择门店所属分类">
                <el-option :label="item.t_Name" :value="item.pom_type" v-for="item in classification"
                  :key="item.pom_type">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="门店名称" prop="pom_name">
              <el-input v-model.trim="ruleForm.pom_name" clearable placeholder="请输入门店名称" maxlength="10"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item prop="pom_remark" label="门店备注">
              <el-input type="textarea" rows="3" placeholder="请输入详细门店备注" v-model.trim="ruleForm.pom_remark"
                maxlength="30">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </w-dialog>

    <!-- 商品详情 -->
    <ProductDetails ref="onProductRef" @onConfirm="onConfirm"></ProductDetails>

    <!-- 入账配置 -->
    <NetConfig ref="netConfig" @submit="handleNetConfig"></NetConfig>

    <!-- 绑定收款播报设备 -->
    <CollectionDialog ref="collecRef"></CollectionDialog>

    <!-- 退款审核员设置 -->
    <refundAuditor ref="refAuditor"></refundAuditor>
  </div>
</template>

<script setup>
  import { ref, reactive, onMounted, computed, watch } from "vue";
  import { BasicApi, StoreApi } from "@/plugins/api.js";
  import { ElMessage } from "element-plus";
  import ProductDetails from "../components/product-details.vue";
  import { useStore } from "vuex";
  import NetConfig from "../components/NetConfig.vue";
  import CollectionDialog from "../components/CollectionDialog.vue";

  const store = useStore();
  const menuTokens = computed(() => store.state.menuToken.menuTokens);  // 权限
  const authData = ref([]);
  watch(
    () => menuTokens.value,
    (data) => {
      if (data.length) {
        authData.value = data;
      }
    },
    {
      deep: true,
      immediate: true,
    }
  );

  // 表格对象
  const tableRef = ref(null);
  // 表格配置数据
  const tableColumns = ref([
    {
      prop: "pom_id",
      label: "门店ID",
    },
    {
      prop: "p_name",
      label: "所属项目",
      color: "--text-third-color",
    },
    {
      prop: "pom_name",
      label: "门店名称",
      color: "--text-third-color",
    },
    {
      type: "block",
      prop: "goods_count",
      label: "在售商品(件)",
      active: "vipClick",
      minWidth: 80,
      token: "n_F685E0282501F26AB304BCC403B2",
    },
    {
      prop: "pom_status",
      type: "switch",
      label: "门店状态",
      token: "n_A67BF76E0682290D073CFF87AB9F",
    },
    {
      type: "customRender",
      prop: "refund_status",
      label: "退款审核",
      minWidth: 80,
    },
    {
      prop: "pom_remark",
      label: "门店备注",
      minWidth: 200,
      color: "--text-third-color",
    },
    {
      type: "operation",
      prop: "",
      label: "操作",
      minWidth: 360,
      bottons: [
        {
          name: "入账配置",
          action: "netConfig",
          token: "n_pxtXOBFsAzdI3fyylbiBy31W9sQQ",
          className: "black-font-btn",
        },
        {
          name: "编辑",
          action: "edit",
          token: "n_5FE3D93896D1F1960223074151A4",
        },
        {
          name: "收款播报",
          action: "collection",
          token: "n_5FE3D93896D1F1960223074151A4",
        },
        {
          name: "审核员",
          action: "verifier",
          token: "n_gSag7P4TU4gUsIXpgDVliMP831",
          className: "theme-font-btn",
        },
      ],
    },
  ]);
  // 筛选配置
  const filters = ref([
    {
      filterType: "select",
      name: "pom_pid",
      value: "",
      placeholder: "请选择项目",
      options: [],
      val: "p_id",
      lab: "p_name",
    },
    {
      filterType: "select",
      name: "pom_type",
      value: "",
      placeholder: "请选择门店分类",
      options: [{ pom_type: "1", t_Name: "线上" }, { pom_type: "2", t_Name: "线下" }],
      val: "pom_type",
      lab: "t_Name",
    },
    {
      filterType: "select",
      name: "pom_status",
      value: "",
      placeholder: "请选择门店状态",
      options: [{ pom_status: "1", s_name: "正常" }, { pom_status: "2", s_name: "禁用" }],
      val: "pom_status",
      lab: "s_name",
    },
    {
      filterType: "search",
      name: "keywords",
      value: "",
      placeholder: "请输入门店关键词或ID进行搜索",
    },
  ]);
  // 新增、编辑填写内容
  const ruleForm = ref({
    pom_pid: "",  // 项目
    pom_type: "",  // 分类
    pom_name: "",  // 名称
    pom_remark: "",  // 备注
  });
  // 验证内容不为空
  const rules = reactive({
    pom_pid: [{ required: true, message: "请选择项目", trigger: "chaneg" }],
    pom_type: [{ required: true, message: "请选择门店所属分类", trigger: "chaneg" }],
    pom_name: [{ required: true, message: "请输入门店名称", trigger: "blur" }],
  });

  // 项目下拉选项
  const projectOptions = ref([]);
  // 分类下拉选项
  const classification = ref([{ pom_type: "1", t_Name: "线上" }, { pom_type: "2", t_Name: "线下" }]);

  onMounted(() => {
    tableRef.value.tableLoad();

    // 获取项目选项数据
    BasicApi.projectSelect().then((res) => {
      if (res.Code === 200) {
        // 新增分类项目选项
        projectOptions.value = res.Data ? res.Data : [];
        // 筛选项目选项
        filters.value[0].options = res.Data ? res.Data : [];
      } else {
        let msg = res.Message ? res.Message : "获取项目数据失败！";
        ElMessage.error(msg);
      }
    });
  });
  // 新增、编辑对话框对象
  const dialogRef = ref(null);
  // 表单对象
  const formRef = ref(null);
  /**
   * 
   * 新增、编辑门店
   * 
   * */
  const openDialog = (row) => {
    if (row.pom_id) {
      //编辑
      const data = JSON.parse(JSON.stringify(row));
      data.pom_type = String(data.pom_type);
      ruleForm.value = data;
    } else {
      // 新增
      ruleForm.value = {
        pom_pid: "",  // 项目
        pom_type: "",  // 分类
        pom_name: "",  // 名称
        pom_remark: "",  // 备注
      };
    }
    dialogRef.value.show();
  };
  /**
   * 
   * 新增/编辑 确认提交按钮
   * 
   * */
  const handleSure = () => {
    formRef.value.validate((valid) => {
      if (valid) {
        dialogRef.value.isLoading = true;
        const data = JSON.parse(JSON.stringify(ruleForm.value));
        let url = "";
        if (data.pom_id) {
          // 编辑
          url = "editPolymeriza";
        } else {
          // 新增
          url = "addPolymeriza";
        }
        // console.log("data", data, url);
        StoreApi[url](data).then((res) => {
          dialogRef.value.isLoading = false;
          const text = data.pom_id ? "修改" : "新增";
          if (res.Code === 200) {
            ElMessage.success(`门店${text}成功！`);
            dialogRef.value.close();
            tableRef.value.tableLoad();
          } else {
            let msg = res.Message ? res.Message : `门店${text}失败！`;
            ElMessage.error(msg);
          }
        });
      }
    });
  };
  /**
   * 
   * 门店状态事件
   * 
   * */
  function changePolymerizationStatus(row) {
    if (row.pom_mpid == 0) {
      ElMessage.error("请先设置入账配置！");
      return false;
    }
    let data = {
      pom_id: row.pom_id,
      pom_status: row.pom_status == 1 ? 2 : 1,  // 1正常 2禁用
    };
    StoreApi.updatePolymerizaStatus(data).then((res) => {
      if (res.Code === 200) {
        ElMessage.success("操作成功！");
        tableRef.value.tableLoad();
      } else {
        let msg = res.Message ? res.Message : "操作失败！";
        ElMessage.error(msg);
      }
    });
  }
  /**
   * 
   * 点击在售商品查看商品详情
   * 
   * */
  const onProductRef = ref(null);
  const openCommodity = (row) => {
    onProductRef.value.openDialog(row);
  };
  /**
   * 
   * 修改库存后重新获取商品详情
   * 
   * */
  const onConfirm = () => {
    tableRef.value.tableLoad();
  }
  // 入账配置对象
  const netConfig = ref(null);
  /**
   * 
   * 打开入账配置对话框
   * 
   * */
  function openNetConfig(row) {
    netConfig.value.openDialog(row);
  }
  /**
   * 
   * 入账配置确定按钮
   * 
   * */
  function handleNetConfig(data) {
    StoreApi.setPolymerizaDivide(data).then((res) => {
      netConfig.value.closeDialogLoading();
      if (res.Code === 200) {
        ElMessage.success(`操作成功！`);
        netConfig.value.closeDialog();
        // 重新获取列表数据
        tableRef.value.tableLoad();
      } else {
        let msg = res.Message ? res.Message : `操作失败！`;
        ElMessage.error(msg);
      }
    });
  }

  const collecRef = ref(null);
  /**
   * 
   * 绑定收款播报设备
   * 
   * */
  function openCollection(row) {
    collecRef.value.openDialog(row);
  }
  /**
  * 
  * 退款审核开关事件
  * 
  * **/
  function refundStatusChange(row) {
    StoreApi.setPomRefundStatus({ pom_id: row.pom_id, pom_refund_status: row.pom_refund_status == 1 ? 2 : 1 }).then((res) => {
      if (res.Code === 200) {
        ElMessage.success("操作成功！");
        tableRef.value.tableLoad();
      } else {
        let msg = res.Message ? res.Message : "操作失败！";
        ElMessage.error(msg);
      }
    });
  }
  const refAuditor = ref(null);
  /**
  * 
  * 打开审核员弹框
  * 
  * **/
  function openVerifier(row) {
    refAuditor.value.openDialog('store', row,);
  }
</script>
<style lang="scss">
  .vip-container {
    font-family: "Source Han Sans CN";

    .content {
      padding: 15px 20px 20px;
    }

    .vip-dialog {
      .el-dialog {
        min-width: 600px;

        .el-dialog__body {
          padding: 30px;

          .el-divider--horizontal {
            margin: 10px 0;
          }
        }
      }
    }
  }
</style>